/**
 * Admin Bot Messages route segment, relative to the Admin domain. This package
 * owns the Bot Messages URL: `botMessagesConfig` builds its route path, nav url
 * and WS-login skip path from these. The page has no detail route and links
 * nowhere else, so there is no page-URL builder.
 *
 * The URL is literal: the app mounts the Admin domain at `adminRoutes.path`,
 * and the dashboard's admin feature drift test keeps it resolving to the route
 * the app registers for it. This module has no imports, so the boot-path
 * feature config can read it without loading any UI.
 */
export const BOT_MESSAGES_ROUTE_PATH = 'bot-messages';

/** Absolute URL of the admin Bot Messages page. */
export const BOT_MESSAGES_LIST_URL = '/admin/bot-messages';
